import { inject, Injectable } from '@angular/core';

import { CookieService } from 'ngx-cookie-service';
import { Observable, tap } from 'rxjs';
import { getDomainNameFromHostname } from '@rp/utils';

import { ACCESS_COOKIE, REFRESH_COOKIE, ACCESS_TOKEN, REFRESH_TOKEN } from '../constants';
import { AuthBaseService } from './auth-base.service';
import { PersonalInfo } from '../models';

@Injectable({ providedIn: 'root' })
export class UserAuthService extends AuthBaseService {
  private readonly _cookieService = inject(CookieService);

  constructor() {
    super();

    const accessCookie = this._cookieService.get(ACCESS_COOKIE);
    const refreshCookie = this._cookieService.get(REFRESH_COOKIE);

    if (accessCookie && refreshCookie) {
      this.localStorageService.setValue<string>(ACCESS_TOKEN, accessCookie);
      this.localStorageService.setValue<string>(REFRESH_TOKEN, refreshCookie);

      const domainName = getDomainNameFromHostname(location.hostname);

      this._cookieService.delete(ACCESS_COOKIE, '/', `.${domainName}`, true, 'None');
      this._cookieService.delete(REFRESH_COOKIE, '/', `.${domainName}`, true, 'None');
    }
  }

  getPersonalInfo(): Observable<PersonalInfo> {
    return this.http
      .get<PersonalInfo>(`${this.userApiHost}/users/personal-info/`)
      .pipe(tap(personalInfo => this.setPersonalInfoToStorage(personalInfo)));
  }
}
